import * as React from 'react';

const Logo = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        viewBox="0 0 450 450"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        stroke="none"
        style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: 1.5,
        }}
        {...props}
    >
        <g id="LL_Logo1">
            <path
                d="M199.475,376.245l-30.52,0l-158,0l0,-30.95l157.57,0l0,-271.54l30.95,0l0,302.49Z"
                style={{ fill: '#ff4e00' }}
            />
            <path
                d="M251.375,376.245l30.52,0l158,0l0,-30.95l-157.569,0l0,-271.54l-30.951,0l0,302.49Z"
                style={{ fill: '#ff4e00' }}
            />
        </g>
    </svg>
);

export default Logo;
